<template>
    <div>
        <v-container>
            <v-row>

                <activity-select :disableComponent="show_all_activities"/>
<!--                        <v-switch-->
<!--                                class="ml-3 mr-5"-->
<!--                                v-model="show_including_vat"-->
<!--                                label="Inkludera moms">-->
<!--                        </v-switch>-->
                <!--        <v-switch-->
                <!--                class="ml-3 mr-5"-->
                <!--                v-model="show_all_activities"-->
                <!--                label="Visa alla aktiviteter">-->
                <!--        </v-switch>-->

            </v-row>
        </v-container>

        <v-container>

            <statistic-card
                    :card-data="todays_active_tickets_data"
                    :is-loading="todays_active_tickets_loading"
            />

            <v-card class="mt-6"
                    elevation="10"
            >
                <v-card-title>{{ $tc('QuickStatistics') }}</v-card-title>
                <v-select
                        class="ml-3 mr-3"
                        :items="earningsPeriods"
                        :label="$tc('Period')"
                        :item-text="'name'"
                        :item-value="'value'"
                        v-model="selectedEarningsPeriod"
                        v-on:change="onQuickStatisticsPeriodChanged()"
                        outlined
                ></v-select>
                <v-container>
                    <statistic-card
                            :card-data="period_sold_tickets_data_money"
                            :is-loading="period_sold_tickets_loading"
                    />

                    <statistic-card
                            class="mt-6"
                            :card-data="period_sold_tickets_data_quantities"
                            :is-loading="period_sold_tickets_loading"
                    />

                    <v-row align="start"
                           justify="start"
                           dense
                           class="mt-6"
                    >
                        <v-col
                                :cols="12"
                                :md="6"
                                :sm="12"
                        >
                            <v-card>
                                <highcharts :options="earningsChartOptions"></highcharts>
                            </v-card>
                        </v-col>
                        <v-col
                                :cols="12"
                                :md="6"
                                :sm="12"
                        >
                            <v-card>
                                <highcharts :options="quantityChartOptions"></highcharts>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-container>

    </div>

</template>

<script lang="ts">
    import i18n from "../i18n";
    import {mapGetters, mapState,} from "vuex";
    import axios from "axios";
    import StatisticCard from "../components/StatisticCard.vue";
    import ActivitySelect from "../components/ActivitySelect.vue";

    export default {
        name: 'Home',
        mounted() {
            if (this.isAuthenticated) {
                this.loadAllData();
            }
        },
        components: {
            ActivitySelect,
            StatisticCard
        },
        computed: {
            ...mapGetters('common', [
                'serverURL',
                'earningsPeriods',
            ]),
            ...mapGetters('auth', [
                'isAuthenticated',
            ]),
            ...mapState('common', [
                'selectedArea',
                'selectedActivity',
            ]),
        },
        methods: {
            loadAllData() {
                this.loadTodaysActiveTickets();
                this.loadPeriodSoldTickets();
            },
            loadTodaysActiveTickets() {
                this.active_tickets_loading = true;
                axios
                    .get(this.serverURL + '/active_tickets/')
                    .then(response => {
                        this.todays_active_tickets_data = response.data;
                        this.todays_active_tickets_loading = false;
                    })
                    .catch(() => {
                        this.todays_active_tickets_loading = false;
                    });
            },
            loadPeriodSoldTickets() {
                this.period_sold_tickets_loading = true;
                axios
                    .get(this.serverURL + '/sold_tickets/', {
                        params: {
                            quick_statistics_period: this.selectedEarningsPeriod,
                        }
                    })
                    .then(response => {
                        this.period_sold_tickets_data_money = response.data.money_data;
                        this.period_sold_tickets_data_quantities = response.data.quantity_data;
                        this.period_sold_tickets_loading = false;
                        this.period_from_date = response.data.from_date;
                        this.period_to_date = response.data.to_date;

                        let earningsChartData = [];

                        for (const dataRow of this.period_sold_tickets_data_money.data_rows) {
                            if (!dataRow.is_sum_row) {
                                earningsChartData.push({
                                    y: parseFloat(dataRow.main_value),
                                    name: dataRow.main_header,
                                    unit: dataRow.main_value_unit,
                                });
                            }
                        }

                        this.earningsChartOptions.series[0].data = earningsChartData;

                        let quantitiesChartData = [];

                        for (const dataRow of this.period_sold_tickets_data_quantities.data_rows) {
                            if (!dataRow.is_sum_row) {
                                quantitiesChartData.push({
                                    y: parseFloat(dataRow.main_value),
                                    name: dataRow.main_header,
                                    unit: dataRow.main_value_unit,
                                });
                            }
                        }

                        this.quantityChartOptions.series[0].data = quantitiesChartData;
                    })
                    .catch(() => {
                        this.period_sold_tickets_loading = false;
                    });
            },
            onQuickStatisticsPeriodChanged() {
                this.loadPeriodSoldTickets();
            }
        },
        watch: {
            selectedActivity() {
                this.loadAllData();
            },
            isAuthenticated() {
                if (this.isAuthenticated) {
                    this.loadAllData();
                }
            },
        },
        data: () => ({
            currency: "SEK",
            show_including_vat: false,
            show_all_activities: false,
            activities: [],
            todays_active_tickets_data: [],
            todays_active_tickets_loading: false,
            period_sold_tickets_data_money: [],
            period_sold_tickets_data_quantities: [],
            period_sold_tickets_loading: false,
            period_from_date: null,
            period_to_date: null,
            earningsChartOptions: {
                title: {
                    text: i18n.tc('EarningsDistribution'),
                },
                tooltip: {
                    pointFormat: '{point.percentage:.1f} %<br>{point.y} {point.unit}'
                },
                series: [{
                    name: i18n.tc('Earnings'),
                    type: "pie",
                    dataLabels: {
                        enabled: true,
                        format: '<b>{point.name}</b>:<br>{point.percentage:.1f} %',
                    },
                    data: []
                }]
            },
            quantityChartOptions: {
                title: {
                    text: i18n.tc('NumberOfSoldTicketsDistribution'),
                },
                tooltip: {
                    pointFormat: '{point.y} {point.unit}'
                },
                series: [{
                    name: i18n.tc('Quantity'),
                    type: "pie",
                    dataLabels: {
                        enabled: true,
                        format: '<b>{point.name}</b>:<br>{point.y} {point.unit}',
                    },
                    data: []
                }]
            },
            selectedEarningsPeriod: 1,
        }),
    }
</script>
